// FTC-2230 Fix provided by Klevu
// https://docs.google.com/spreadsheets/d/1EGoLPMG6c_OQ4IGLLuiybur0yZV__y9KAwMRazFcN08/

// THIS IS THE COPIED CLIENT'S CUSTOMIZATION.

if (klevu_lang == 'cs') {
  klevu.search.modules.locale.globalTranslations = klevu.search.modules.locale.globalTranslations || {};
  klevu.search.modules.locale.globalTranslations.cs = klevu.search.modules.locale.globalTranslations.cs || {};
}
if (klevu_lang == 'lt') {
  klevu.search.modules.locale.globalTranslations = klevu.search.modules.locale.globalTranslations || {};
  klevu.search.modules.locale.globalTranslations.lt = klevu.search.modules.locale.globalTranslations.lt || {};
}
if (klevu_lang == 'pt-PT') {
  klevu_lang = 'pt';
}

klevu.search.modules.locale.globalTranslations[klevu_lang]["Popular Searches"] = theme.strings.popular_searches;
klevu.search.modules.locale.globalTranslations[klevu_lang]["Recent Searches"] = theme.strings.recent_searches;
klevu.search.modules.locale.globalTranslations[klevu_lang]["Suggestions"] = theme.strings.suggestions;
klevu.search.modules.locale.globalTranslations[klevu_lang]["Category"] = theme.strings.category;
klevu.search.modules.locale.globalTranslations[klevu_lang]["Products"] = theme.strings.products;
klevu.search.modules.locale.globalTranslations[klevu_lang]["View All"] = theme.strings.view_all;
klevu.search.modules.locale.globalTranslations[klevu_lang]["We're sorry, no results found for"] = theme.strings.no_results_found;
klevu.search.modules.locale.globalTranslations.en["Category"] = 'Categories';

var isCCcountry = window?.theme?.settings?.is_cc_country;
// End FTC-2230 Fix provided by Klevu

var klevu_maxSuggestionsToShow = 8;
var customStyleContent = `.klevuAutoSuggestionsWrap ul li a:hover,.ku-clearFacet,.kuPopularSearchTerms li a:hover{text-decoration:underline}.kuContainer .kuMulticheck .kuFilterNames ul li a[data-value=White] .kuFilterIcon[style*=background]:after,.kuFilterBox.kuMulticheck .kuFilterNames ul li a span.kuFilterIcon:after{background:url(https://cdn.shopify.com/s/files/1/0520/8899/5991/t/19/assets/filter-tick-icon.svg?v=3848313078784785443) center no-repeat!important}.kuQuickSearchNoRecordFound .kuDividerLine{display:block}.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled>div,.kuQuickSearchFacetedLayout>div,.kuQuickSearchResultsContainer.klevuTarget>.klevuWrap{-webkit-box-shadow:0 2px 8px 0 rgb(0 0 0 / 20%);box-shadow:0 2px 8px 0 rgb(0 0 0 / 20%);border-radius:8px;width:850px!important;max-width:850px!important;left:50%!important;-webkit-transform:translateX(-50%);transform:translateX(-50%);margin-top:20px;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.kuEmptySearchBox.klevuTarget.kuPersonalizedSearchRecsEnabled .klevuQuickSearchingArea,.kuSearchBoxWithTerm [data-container-id=ku_quick_main_content_container]{padding:0!important}.kuSearchBoxWithTerm [data-container-id=ku_quick_main_container],[data-container-id=ku_quick_main_content_container]{padding:25px 40px!important;background:#fff}[data-container-id=ku_quick_main_content_center]{background:#fff;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding-left:25px;border-left:1px solid #bbb}.kuSearchBoxWithTerm [data-container-id=ku_quick_main_content_container]{background:#fff}.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled [ku-container][data-container-role=left],.kuSearchBoxWithTerm [data-container-id=ku_quick_main_header_container]{width:230px!important;min-width:230px;-webkit-box-sizing:border-box;box-sizing:border-box}.kuCarousel,.kuEmptySearchBox.klevuTarget.kuPersonalizedSearchRecsEnabled .klevuProductItemTop,.kuFilterBox .kuFilterNames{height:auto}#klevuCmsContentArea,.klevuAutoSuggestionsWrap+.kuNoResultsPopularSearchesBlock,.klevuCategorySuggestions ul li:nth-child(n+4),.kuCarousel .kuSlide:nth-of-type(n+4),.kuCarousel .nav,.kuFilterButton,.kuFilterClose,.kuSlide .klevuQuickProductPrice br{display:none}.kuCarousel .kuCarousel-content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:0 32px}.klevuResultsBlock .klevuProductsViewAll,.kuCarousel .kuSlide,.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap a{position:static}.kuSearchPersonalizationsContainer{width:100%}.kuSlide .klevuQuickProductPrice{margin-top:0}@media only screen and (min-width:768px){.kuCarousel .kuSlide{width:calc(33.33% - 32px)!important}}.klevuHeadingText,.klevuQuickHeadingText{color:#000;font-family:AvenirNextWorldDemi;font-size:.875rem!important;padding:0!important;margin:10px 0;text-transform:none}.klevuSuggestionHeading,.klevuTarget.kuPersonalizedSearchRecsEnabled .klevuResultsBlock .klevuSuggestionHeading{padding:0}.klevuTarget.kuPersonalizedSearchRecsEnabled .klevuResultsBlock .klevuSuggestionHeading .klevuHeadingText{color:#000;font-family:AvenirNextWorldBold;font-size:1.25rem!important;text-transform:none;margin:10px 0 0;margin-bottom:10px!important;padding:0!important}.klevuAutoSuggestionsWrap ul li:hover,.kuFilterBox.kuMulticheck .kuFilterNames ul li a:hover span.kuFilterIcon:before,.kuFilterBox.kuMulticheck .kuFilterNames ul li.kuSelected a span.kuFilterIcon:before,.kuNoResultsPopularSearchTerms a:hover,.kuNoResultsPopularSearchTerms:hover,.kuPopularSearchTerms li:hover{background:0 0}.klevuAutoSuggestionsWrap ul li a,.kuPopularSearchTerms li a{color:#000;margin-bottom:15px;padding:0}.kuNoResultsPopularSearchTerm,.kuNoResultsPopularSearchTerm a{line-height:14px;color:#000;margin-bottom:15px;padding:0}.kuNoResultsPopularSearchHeading{margin:10px 0!important}.klevuPopularProductItemBottom .klevu-desc-l2,.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom .klevu-desc-l2,.kuDropItemsPerpage,.kuLandingResultsViewSwitchContainer,.kuQuickSearchNoRecordFound .kuNoResultsPopularSearchesBlock,.kuSearchResultsPageContainer .kuResultsHeadingTitleContainer,.kuTabs{display:none!important}.kuQuickSearchNoRecordFound{background-color:transparent}.kuQuickNoResultsMessage{color:#000;margin-bottom:15px;padding:0;font-family:AvenirNextWorldRegular!important}.klevuProduct .badge.badge-last-chance{background-color:#dc3545;color:#fff}.klevuProduct .badge-product-of-the-week{background:#f39b23;color:#fff}[data-container-id=ku_quick_main_container]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.klevuResultsBlock .klevuQuickSearchResults ul{display:grid;grid-template-columns:1fr 1fr 1fr;grid-gap:16px}.klevuResultsBlock .klevuQuickSearchResults ul:before,.noUi-handle:after,.noUi-handle:before{content:none}.klevuResultsBlock .klevuQuickSearchResults ul li{-ms-flex-preferred-size:100%;flex-basis:100%;padding:0;border:none}.klevuAutoSuggestionsWrap{padding:0;border-bottom:none;margin-bottom:10px}.klevuResultsBlock .klevuProductsViewAll a{color:#000;font-family:AvenirNextWorldDemi!important;text-decoration:underline;font-size:13px;text-transform:none;border-bottom:none}.klevuResultsBlock .klevuProductsViewAll a:hover,.ku-clearFacet:hover{text-decoration:none}.klevuResultsBlock .klevuQuickSearchResults ul li a.klevuQuickProductInnerBlock{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;padding:0;-ms-flex-direction:column;flex-direction:column}.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemTop{width:100%;padding:0}.klevuResultsBlock .klevuQuickSearchResults .klevuQuickImgWrap{height:auto!important;max-height:100%!important;border:none}.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom{padding:0;width:100%}.klevuResultsBlock .klevuQuickSearchResults ul li .klevuQuickProductDescBlock{margin:0}.klevuResultsBlock .klevuQuickSearchResults ul li .klevuQuickProductName{color:#000;font-family:AvenirNextWorldDemi;font-size:.875rem;margin-top:10px;text-decoration:none;font-weight:700}.klevuQuickProductPrice{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.klevuResultsBlock .klevuQuickSearchResults ul li .klevuQuickOrigPrice{margin-left:5px;font-size:12px}.kuProductHeadingWrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[data-block-id=ku_landing_result_header]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.kuSearchResultsPageContainer .kuDropdown .kuDropdownLabel{border:none;margin:0;color:#707070;font-size:1rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.kuFilterTags,.kuFilterTagsContainer,[data-filter=Sustainable] .kuFilterHead{display:-webkit-box;display:-ms-flexbox}.kuSearchResultsPageContainer .kuDropSortBy{margin:0 0 20px}.kuSearchResultsPageContainer .kuDropdown .kuDropdownLabel .kuSortbyLabel{font-size:1rem;color:#000;font-family:AvenirNextWorldBold;margin-right:10px}.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions{width:100%;-webkit-box-shadow:0 0 2px #00000026;box-shadow:0 0 2px #00000026;background-color:#fff}.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions .kuDropOption{padding:5px 15px 0;-webkit-box-shadow:0 1px #00000026;box-shadow:0 1px #00000026;font-size:1rem;border:1px solid transparent;width:100%;cursor:pointer;line-height:30px;text-align:left}.page-search-results .kuFilters{margin-top:60px;padding:0}[ku-container][data-container-role=left]{width:290px;min-width:290px;max-width:290px}[data-filter=Sustainable] .kuFilterHead{display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}[data-filter=Sustainable] .eco-friendly-icon-wrapper,[data-filter=sustainable] .eco-friendly-icon-wrapper{padding-top:0}.page-search-results .kuContainer .kuFilterHead{text-transform:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.ku-clearFacet{background:0 0;border:none;color:#707070;font-family:AvenirNextWorldRegular;font-size:.875rem}.klevuResultsBlock .klevuQuickSearchResults img,.kuFilterTag{background-color:#f4f4f4}.kuFacetLabel{-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;text-align:left}.kuFilterTags{display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:20px}.ku-kuFilterTagsLabel,.kuSearchResultsPageContainer .kuResults ul li .kuName a{color:#000;font-family:AvenirNextWorldDemi;font-size:1rem}.kuFilterTagClearAll{color:#707070;font-family:AvenirNextWorldRegular;font-size:.875rem;text-decoration:underline!important;border:none;margin:0;cursor:pointer}.kuFilterTagClearAll:hover{text-decoration:none!important}.kuFilterTagsContainer{display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap}.kuFilterTagsWrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:20px}.kuFilterTag{color:#000;font-size:.875rem;padding:4px 10px;margin-bottom:7px;margin-right:5px}.klevuQuickProductName,.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li .klevuQuickProductName{color:#000;font-family:AvenirNextWorldDemi!important;font-size:.875rem!important}.kuFilterTagsContainer .kuFilterTagValue{background-color:none;margin:0;padding:0;color:#000;font-size:.875rem}.kuFilterTagsContainer .kuFilterTagKey{padding:0;margin:0 5px 0 0;color:#000;font-size:.875rem}[data-container-id=ku_landing_main_content_center]{padding-left:30px}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap{border:none}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap{background:#f4f4f4;height:260px!important;padding-bottom:140%;position:relative;margin-bottom:20px}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap a img{max-height:100%!important;width:100%!important;height:auto;bottom:-100%;top:-100%;left:0;right:0}.kuResults .product-card_quickview{position:absolute;bottom:10px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);z-index:2;max-width:180px;width:100%;padding:0;-webkit-transition:.35s;transition:.35s;opacity:0;font-weight:400;font-family:AvenirNextWorldDemi;font-size:14px;line-height:30px}.kuSearchResultsPageContainer .kuResults ul li:hover .product-card_quickview{-webkit-transition:.35s;transition:.35s;opacity:1}.kuResults .product-card_wishlist{position:absolute;top:2px;right:2px;z-index:2}.kuSearchResultsPageContainer .kuResults ul li .kuName{color:#000;font-family:AvenirNextWorldDemi;font-size:1rem;margin-bottom:8px}.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdBottom{height:auto;padding:0}.kuPrice .kuSalePrice{font-size:1.625rem;color:#000;font-family:AvenirNextWorldBold;font-weight:700;overflow:visible}.kuProdBottom .kuPrice{overflow:visible;margin:15px 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.kuPriceSlider{padding:40px 20px}.noUi-horizontal{height:4px}.noUi-horizontal .noUi-handle{border:1px solid #414042;border-radius:50%;background:#fff;cursor:pointer;width:18px;height:18px}.noUi-tooltip{border:none;margin:0;padding:0}.kuFilterTagsContainer .kuFilterTagValue:hover{background-color:none!important}.kuFilterTagsContainer .kuFilterTagValue{margin-right:5px}.kuFilterBox .kuFilterIcon{width:23px;height:23px;margin-right:10px!important}.kuFilterBox .kuFilterIcon:before{width:23px;height:23px;border:1px solid #dadada;border-radius:2px}.kuFilterBox .kuFilterNames ul li{margin:4px 0}.kuFilterBox.kuMulticheck .kuFilterNames ul li a:hover span.kuFilterIcon:after,.kuFilterBox.kuMulticheck .kuFilterNames ul li.kuSelected a span.kuFilterIcon:after{opacity:1;-webkit-transform:translateY(-50%)!important;transform:translateY(-50%)!important}.kuFilterBox.kuMulticheck .kuFilterNames ul li a span.kuFilterIcon:after{position:absolute;top:50%!important;-webkit-transform:translateY(-50%)!important;transform:translateY(-50%)!important;content:'';height:12px!important;width:14px!important;left:5px!important;opacity:0;-webkit-transform:scale(0) rotate(-45deg)!important;transform:scale(0) rotate(-45deg)!important;border:none!important}.kuContainer .kuMulticheck .kuFilterNames ul li .kuFilterIcon[style*=background]:after{background:url(https://cdn.shopify.com/s/files/1/0520/8899/5991/t/19/assets/filter-tick-icon-white.svg?v=5615081262966347581) center no-repeat!important}.klevuQuickProductName{-webkit-line-clamp:2}.kuCarousel .klevuQuickSalePrice{font-weight:700;margin-bottom:5px;color:#333}@media only screen and (max-width:860px){.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled>div,.kuQuickSearchFacetedLayout>div,.kuQuickSearchResultsContainer.klevuTarget>.klevuWrap{width:100%!important;max-width:100%!important;height:auto;max-height:calc(100vh - 80px)!important}}@media only screen and (max-width:768px){.kuEmptySearchBox.klevuTarget.kuPersonalizedSearchRecsEnabled .kuPopularSearchTerms{overflow:auto}.klevuAutoSuggestionsWrap ul li a,.kuPopularSearchTerms li a{white-space:nowrap}.kuCarousel{padding-bottom:10px}.kuSearchBoxWithTerm .klevuResultsBlock .klevuQuickSearchResults .klevuQuickImgWrap{max-height:100px!important}.klevuResultsBlock .klevuQuickSearchResults img{width:auto!important;background-color:#f4f4f4}[ku-container][data-container-role=content],[ku-container][data-container-role=main]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.kuCarousel .kuSlide,.page-search-results .kuContainer .kuCollapse+.kuFilterNames{display:block!important}.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled [ku-container][data-container-role=left],.kuSearchBoxWithTerm [data-container-id=ku_quick_main_header_container]{width:100%!important;padding:20px!important}.kuSearchBoxWithTerm [data-container-id=ku_quick_main_header_container]{height:calc(100vh - 75px);overflow:scroll}.klevuAutoSuggestionsWrap ul,.kuPopularSearchTerms ul{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;width:100%;overflow:auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.klevuAutoSuggestionsWrap ul li,.kuPopularSearchTerms li{margin-right:20px}.klevuTarget.kuPersonalizedSearchRecsEnabled .klevuResultsBlock .klevuSuggestionHeading .klevuHeadingText{margin-top:0!important;font-size:14px!important}.kuCarousel .kuSlide{margin:0 8px;width:calc(30% - 8px)!important;position:absolute}.klevuResultsBlock .klevuQuickSearchResults ul{grid-template-columns:1fr;overflow-y:auto}.kuSearchResultsPageContainer.kuLEFTFilters .kuResults ul{grid-template-columns:1fr 1fr}[data-container-id=ku_landing_main_content_center]{padding-left:0}.kuFilterButton{display:-webkit-box;display:-ms-flexbox;display:flex;margin-right:auto;width:130px;background:url(https://cdn.shopify.com/s/files/1/0520/8899/5991/t/19/assets/filters-icon.svg?v=12506078057155258453) 95px no-repeat;border:1px solid #d3d3d3;border-radius:5px;grid-area:filter-mobile;color:#000;font-size:.875rem;font-family:AvenirNextWorldDemi;text-transform:capitalize;text-align:left;padding:0 10px;height:40px;line-height:40px}.ku-filters-open .page-search-results .kuContainer .kuFilters{left:0;padding-top:40px}.kuFilterClose{position:absolute;right:30px;top:20px;background:url(https://cdn.shopify.com/s/files/1/0520/8899/5991/t/19/assets/close-icon.svg?v=13240198641535193278) center no-repeat;display:block;height:10px;width:10px;border:none}[ku-container][data-container-role=left]{width:100%!important;max-width:100%!important}.kuSearchResultsPageContainer .kuResults ul{grid-gap:16px}.kuSearchBoxWithTerm [data-container-id=ku_quick_main_container],[data-container-id=ku_quick_main_content_container]{padding:0!important}.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer .kuRecentSearchesBlock{display:none}.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer .kuPopularSearchesBlock{border-bottom:1px solid #d3d3d3}.kuCarousel .nav{display:block}[data-container-id=ku_quick_main_content_center]{border-left:0}.kuSearchBoxWithTerm [data-container-id=ku_quick_main_content_center]{border-top:1px solid #d3d3d3;padding-left:0}.klevuResultsBlock .klevuQuickSearchResults ul li a.klevuQuickProductInnerBlock{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;padding:0 0 10px;border-bottom:.5px solid #d3d3d3;-ms-flex-direction:row;flex-direction:row}.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemTop{width:100px;padding:0}.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom .klevu-desc-l2{display:none!important}.klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom{min-height:auto!important;padding:0 0 0 10px;width:70%}.kuCarousel{height:210px}.kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled>div,.kuProductHeadingWrapper,.kuQuickSearchFacetedLayout>div,.kuQuickSearchResultsContainer.klevuTarget>.klevuWrap{margin-top:10px}}@media only screen and (max-width:525px){.kuCarousel .kuSlide{width:calc(40% - 8px)!important}.kuCarousel{height:240px}}`;

klevu.coreEvent.build({
  name: "setRemoteConfigQuickOverride",
  fire: function () {
    // klevu.getSetting(klevu.settings, "settings.theme.quickSearch").loadDefaultStyles = false;
    if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigQuick.build", false)) {
      return true;
    }
    return false;
  },
  maxCount: 150,
  delay: 100
});

klevu.coreEvent.attach("setRemoteConfigQuickOverride", {
  name: "attachRemoteConfigQuickOverride",
  fire: function () {
    klevu.each(
      klevu.search.extraSearchBox, function (key, box) {
        box.getScope().chains.request.control.addAfter("initRequest", {
          name: "updateCurrency",
          fire: function (data, scope) {
            klevu.search.modules.currencySetUp(data, scope);
            klevu.search.modules.addCustomerGroupToQuery(data, scope);

          }
        });


        box.getScope().chains.template.events.add({
          name: "changePrecisionQuick",
          fire: function (data, scope) {
            if (document.getElementsByClassName('klevuQuickSalePrice').length > 0) {
              for (const i of document.getElementsByClassName('klevuQuickSalePrice')) {
                i.innerText = i.innerText.replace(',00', '').replace('.00', '');
                let price = (parseFloat(i.innerText.replace(',', '.').replace('€', '').replace('kr.', '').replace('£', '').replace('zł', '')));
                if (price == 0) {
                  i.innerText = " ";
                }
              }
            }
            if (document.getElementsByClassName('klevuQuickOrigPrice').length > 0) {
              for (const i of document.getElementsByClassName('klevuQuickOrigPrice')) {
                i.innerText = i.innerText.replace(',00', '').replace('.00', '');
              }
            }

          }
        });

        box.getScope().template.setTemplate(klevuQuickProductBlockTitleHeaderCustom, "klevuQuickProductBlockTitleHeader", true);
        box.getScope().template.setTemplate(klevuQuickTemplateBaseCustom, "klevuTemplateBase", true);

        //klevu change
        box.getScope().template.setTemplate(klevuQuickTrendingProductBlockCustom, "klevuQuickTrendingProductBlock", true);
        box.getScope().template.setTemplate(klevuQuickRecentViewedProductBlockCustom, "klevuQuickRecentViewedProductBlock", true);

        box.getScope().template.setHelper("isScreenWidthSmaller", function isScreenWidthSmaller(screenWidth) {
          if (!screenWidth) screenWidth = 768;
          var widthOfScreen = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          return widthOfScreen <= screenWidth;
        });
        // the end of klevu change

      }
    );

    klevu.dom.helpers.addElementToHead({
      name: "klevu-custom-styles",
      content: customStyleContent,
      type: "css"
    });

    klevu({
      powerUp: {
        quick: true
      }
    });
  }
});

klevu.coreEvent.build({
  name: "setRemoteConfigLandingOverride",
  fire: function () {
    if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build") || klevu.getSetting(klevu, "settings.flags.setRemoteConfigCatnav.build")) {
      if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build")) {
        window.pageType = 'landing';
        window.setRemoteConfig = 'setRemoteConfigLanding';
      }
      if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigCatnav.build")) {
        window.pageType = 'catnav';
        window.setRemoteConfig = 'setRemoteConfigCatnav';
      }
      return true;
    }
    return false;
  },
  maxCount: 250,
  delay: 50
});

klevu.coreEvent.attach("setRemoteConfigLandingOverride", {
  name: "attachRemoteConfigLandingOverrideKlevu",
  fire: function () {

    // if (window.pageType === "catnav") {
    //   try {
    //     klevu.search[window.pageType].getScope().chains.request.control.addAfter("initRequest", {
    //       name: "updateCollectionFiltersByMetafields",
    //       fire: function (data, scope) {
    //         klevu.search.modules.updateResultNumber(data, scope);
    //       }
    //     });
    //   }
    //   catch (error) {
    //     console.log(error);
    //   }
    // }

    klevu.search[window.pageType].getScope().chains.template.events.add({
      name: "changeImageSizeAndCurrencyQuick",
      fire: function (data, scope) {

        if (document.getElementsByClassName('kuSalePrice').length > 0) {
          for (const i of document.getElementsByClassName('kuSalePrice')) {
            i.innerText = i.innerText.replace(',00', '').replace('.00', '');
          }
        }
        if (document.getElementsByClassName('kuOrigPrice').length > 0) {
          for (const i of document.getElementsByClassName('kuOrigPrice')) {
            i.innerText = i.innerText.replace(',00', '').replace('.00', '');
          }
        }
      }
    });

    klevu.search[window.pageType].getScope().template.setTemplate(
      klevuLandingTemplateSortByCustom,
      "sortBy",
      true
    );

    klevu.search[window.pageType].getScope().template.setTemplate(
      klevuLandingTemplateFiltersCustom,
      "filters",
      true
    );

    klevu.search[window.pageType].getScope().template.setTemplate(
      klevuLandingTemplateResultsCustom,
      "results",
      true
    );

    klevu.search[window.pageType].getScope().template.setTemplate(
      kuFilterTagsTemplateCustom,
      "kuFilterTagsTemplate",
      true
    );

    klevu.search[window.pageType].getScope().template.setTemplate(
      klevuLandingTemplateProductBlockCustom,
      "productBlock",
      true
    );
    //Added by FlyingTiger- FTC-2373-2 - Set template of pagination to custom template
    klevu.search.landing.getScope().template.setTemplate(
      klevuLandingTemplatePaginationCustom,
      "pagination",
      true
    );
    //Added by FlyingTiger -FTC-2373-2 - Set template of number of product showing to custom template
    klevu.search.landing.getScope().template.setTemplate(
      klevuLandingResultsShowingCustom,
      "resultsShowing",
      true
    );



    klevu.search[window.pageType].getScope().chains.request.control.addAfter("initRequest", {
      name: "filterToReturn",
      fire: function (data, scope) {
        klevu.search.modules.updateResultNumber(data, scope);

        klevu.search.modules.updateMaxFilterOptions(data, scope);
        klevu.search.modules.addTranslations(data, scope);
        klevu.search.modules.addCustomerGroupToQuery(data, scope);
        klevu.search.modules.currencySetUp(data, scope);
        // Added by flyingtiger 
        klevu.search.modules.updatePageTitle();

        // Restore Search Params On Page Load
        klevu.search.modules.addParamsToURL.base.restoreSearchParamsOnPageLoad(data, scope);
        klevu.search.modules.addCustomerGroupToQuery(data, scope);
      }
    });


    klevu.search[window.pageType].getScope().chains.template.events.add({
      name: "addURLtoHistory",
      fire: function (data, scope) {
        // Added by FlyingTiger - FTC-2373-2 - Add selected FILTERS and PAGINATION to the URL
        klevu.search.modules.addParamsToURL.base.addURLtoHistory(data, scope);
      }
    });

    window.onpopstate = function (event) {
      try {
        // passing activeQueryId because it's lost once we reset the data below
        var activeQueryId = klevu.getObjectPath(klevu.search[window.pageType].getScope().element.kObject.getScope().data, "context.activeQueryId");

        // code to get ready to reset all the data
        var data = klevu.search[window.pageType].getScope().element.kObject.getScope().data;
        var scope = klevu.search[window.pageType].getScope().element;
        scope.kScope.data = scope.kObject.resetData(scope.kElem);
        scope.kScope.data.context.keyCode = 0;
        scope.kScope.data.context.eventObject = event;
        scope.kScope.data.context.event = "keyUp";
        scope.kScope.data.context.preventDefault = false;

        // Get payload for Filters & Pagination
        klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(data, scope, activeQueryId);

        // Fire request, re-render results
        klevu.event.fireChain(scope.kScope, "chains.events.keyUp", scope, scope.kScope.data, event);
      } catch (error) {
        console.log(error)
      }
    };








    klevu.search[window.pageType].getScope().chains.template.events.add({
      name: "ku-facet-clean",
      fire: function (data, scope) {
        klevu.search.modules.cleanIndividualFacets(data, scope);
        // Added by FlyingTiger - FTC-2539-1: [SERPs, Mobile] Filter drawer does not close when tapping outside of the drawer
        const kuFilterButton = document.querySelector('.kuFilterButton');
        const kuFilterClose = document.querySelector('.kuFilterClose');
        const kuFilters = document.querySelector('.kuFilters');
        const drawerOverlay = document.querySelector('.klevu_overlay');
        const body = document.getElementsByTagName('body')[0];

        if (kuFilters) {
          if (kuFilterButton) {
            klevu.event.attach(kuFilterButton, "click", function () {
              body.classList.toggle('ku-filters-open');
              drawerOverlay.classList.toggle('klevu_overlay_active');
            });
          }

          if (kuFilterClose) {
            const computedStyle = window.getComputedStyle(kuFilters);
            if (computedStyle.left === '0px' && !drawerOverlay.classList.contains('klevu_overlay_active')) {
                drawerOverlay.classList.toggle('klevu_overlay_active');
            }        

            const closeHandler = function () {
              body.classList.toggle('ku-filters-open');
              drawerOverlay.classList.toggle('klevu_overlay_active');
            };

            klevu.event.attach(kuFilterClose, "click", closeHandler);
            klevu.event.attach(drawerOverlay, "click", closeHandler);
          }
        }
      }
    });

    window.onscroll = function (ev) {
      var footerHeight = document.getElementById("shopify-section-footer").clientHeight;
      var currentPostion = document.documentElement.scrollTop || document.body.scrollTop;
      if (window.pageType === "catnav" || (window.pageType === "landing" && (window.innerHeight + Math.ceil(window.pageYOffset)) >= document.body.offsetHeight - footerHeight)) {
        var hasAlreadyTriggered = window.pageType === "landing" ? klevu.getObjectPath(klevu.search[window.pageType].getScope().data, "context.triggeredFromInfiniteScroll") : klevu.getObjectPath(klevu.search.catnav.getScope().data, "context.triggeredFromInfiniteScroll");
        if (!hasAlreadyTriggered) {
          var target = window.pageType === "landing" ? klevu.getSetting(klevu.search[window.pageType].getScope().settings, "settings.search.searchBoxTarget") : klevu.getSetting(klevu.search.catnav.getScope().settings, "settings.search.searchBoxTarget");
          var activeQueryId = window.pageType === "landing" ? klevu.getObjectPath(klevu.search[window.pageType].getScope().data, "context.activeQueryId") : klevu.getObjectPath(klevu.search.catnav.getScope().data, "context.activeQueryId");
          if (activeQueryId) {
            var kuLoadMoreBtn = document.querySelector(".kuLoadMoreBtn");
            if (kuLoadMoreBtn) {

              /* 
              * FTC-1598 - TM - Added by flyingtiger - 15-06-2022
              * Function to stop auto-scroll to top after loading new results on Firefox and Safari
              * 
              * FTC-280 - Add a loading icon/spinner for infinite loading
              *
              */
              var browser = navigator.userAgent.toLowerCase();
              var numOfResults = window.pageType === "landing" ? klevu.search[window.pageType].getScope().data?.scope?.kData?.query?.productList?.meta?.totalResultsFound : klevu.search.catnav.getScope().data?.scope?.kData?.query?.productList?.meta?.totalResultsFound;
              var container = document.querySelector('.kuResults > ul');
              var interval;
              var scrollingIssue = false;

              kuLoadMoreBtn.innerHTML = "Show more"

              kuLoadMoreBtn.addEventListener("click", function (e) {
                e.preventDefault();
                if (numOfResults !== container.childElementCount) {
                  showLoadingIcon();

                  if (window.pageType === "landing") {
                    stopScroll();
                  }
                }
              });

              // Click button to load new products
              if (window.pageType === "landing") {
                kuLoadMoreBtn.click();
                scrollingIssue = true;
              }

              waitForNewProducts('.kuResults > ul', scrollingIssue);

              function stopScroll() {
                interval = setInterval(scrollToCurrentPosition, 1);
              }

              function enableScroll() {
                clearInterval(interval);
              }

              function scrollToCurrentPosition() {
                window.scrollTo(0, currentPostion);
              }

              function addCounter() {
                var progress_bar = container.childElementCount / numOfResults * 100;
                var kuPagination = document.querySelector(".pagination-wrapper");
                kuPagination.insertAdjacentHTML('beforebegin', `<div class="page-total">
                              <span>1 - ${container.childElementCount} <span>of</span> ${numOfResults} <span>total</span></span>
                              <div class='progress_bar'><div class='progress_bar_bg' style="width: ${progress_bar}%"></div></div>
                            </div>`);

                if (container.childElementCount === numOfResults) {
                  hidePageTotal();
                }
              }

              function hidePageTotal() {
                document.querySelector(".kuInfiniteScrollContainer").classList.add("hidden");
              }

              function showLoadMoreButton() {
                kuLoadMoreBtn.classList.remove("hide");
              }

              if (window.pageType === "catnav" && !document.querySelector(".page-total")) {
                showLoadMoreButton();
                addCounter();
              }

              function showLoadingIcon() {
                window.showLoadingIcon();
              }

              function hideLoadingIcon() {
                window.hideLoadingIcon();
              }

              function waitForNewProducts(selector, scrollingIssue) {
                return new Promise(resolve => {
                  const observer = new MutationObserver(mutations => {
                    if (document.querySelector(selector)) {
                      setTimeout(function () {
                        hideLoadingIcon();
                        if (scrollingIssue && window.pageType === "landing") {
                          enableScroll();
                        }
                      }, 10);
                      observer.disconnect();
                    }
                  });
                  observer.observe(document.body, {
                    childList: true,
                    subtree: true
                  });
                });
              }
              // End FTC-1598 and FTC-280
            }
          }
        }
      }
    };

    if (window.pageType === 'landing') {
      klevu({
        powerUp: {
          landing: true
        }
      });
    }

    if (window.pageType === 'catnav') {
      klevu({
        powerUp: {
          catnav: true
        }
      });
    }

  }
});


(function (klevu) {
  klevu.extend(true, klevu.search.modules, {
    updateMaxFilterOptions: function (data, scope) {
      const maxFilterAmount = 30;
      klevu.each(data.request.current.recordQueries, function (key, query) {
        query.filters.filtersToReturn.options.limit = maxFilterAmount;
      });
    },
    updateResultNumber: function (data, scope) {
      klevu.each(data.request.current.recordQueries, function (key, query) {
        query.settings.limit = 48;
      });
    },
    cleanIndividualFacets: function (data, scope) {
      klevu.each(klevu.dom.find(".ku-clearFacet"), function (key, element) {
        klevu.event.attach(element, "click", function (event) {
          event.stopPropagation();
          var target = klevu.dom.helpers.getClosest(this, ".klevuTarget");
          if (target === null) {
            return;
          }
          var options = klevu.dom.helpers.getClosest(this, ".klevuMeta");
          if (options === null) {
            return;
          }
          var elScope = target.kElem;
          elScope.kScope.data = elScope.kObject.resetData(elScope.kElem);
          elScope.kScope.data.context.keyCode = 0;
          elScope.kScope.data.context.eventObject = event;
          elScope.kScope.data.context.event = "keyUp";
          elScope.kScope.data.context.preventDefault = false;

          var facetName = event.target.dataset.facet ? event.target.dataset.facet : undefined;

          try {
            var filterArray = Array.from(
              klevu.search[window.pageType].getScope().data.localOverrides.query
                .productList.filters.applyFilters.filters
            );

            if (filterArray.length < 1) {
              return;
            }
          } catch (error) {
            console.log(error);
            return;
          }

          const newFacets = filterArray.filter(item => item.key !== facetName);

          klevu.setObjectPath(
            elScope.kScope.data,
            "localOverrides.query." +
            options.dataset.section +
            ".settings.offset",
            0
          );
          klevu.setObjectPath(
            elScope.kScope.data,
            "localOverrides.query." +
            options.dataset.section +
            ".filters.applyFilters.filters",
            newFacets
          );
          klevu.event.fireChain(
            elScope.kScope,
            "chains.events.keyUp",
            elScope,
            elScope.kScope.data,
            event
          );
        });
      });
    },
    addCustomerGroupToQuery: function (data, scope) {
      klevu.each(data.request.current.recordQueries, function (key, query) {
        if (typeof klevu_currentCurrencyCode !== "undefined") {
          klevu.setObjectPath(
            data,
            "localOverrides.query." + query.id + ".settings.priceFieldSuffix",
            klevu_currentCurrencyCode);
        }

      });
    },
    updatePageTitle: function () {

      var pageTitle = document.querySelector(".title-search-results");
      var url = new URL(window.location.href);
      var q = url.searchParams.get("q");
      if (pageTitle) {
        pageTitle.innerHTML = q;
      }

      var x = setInterval(function () {
        if (document.querySelector(".kuResults ul") && document.querySelector(".kuResults ul").childElementCount > 0) {
          if (window.pageType === "landing") {
            var numOfResults = klevu.search[window.pageType].getScope().data?.scope?.kData?.query?.productList?.meta?.totalResultsFound !== undefined ? klevu.search[window.pageType].getScope().data?.scope?.kData?.query?.productList?.meta?.totalResultsFound : klevu.search[window.pageType]?.getScope()?.data?.response?.current?.queryResults[0]?.meta?.totalResultsFound;
            var numOfResultsElement = document.querySelector(".search-items-number");

            if (numOfResultsElement && numOfResults) {
              numOfResultsElement.innerHTML = numOfResults;
              clearInterval(x);
            }
          }
        }
      }, 1000);
    },
    currencySetUp: function (data, scope) {
      scope.kScope.currency.setCurrencys({
        'EUR': {
          string: "€",
          format: "%s%s",
          atEnd: false,
          precision: 2,
          thousands: ".",
          decimal: ",",
          grouping: 3
        },
        'PLN': {
          string: "zł",
          format: "%s %s",
          atEnd: true,
          precision: 2,
          thousands: ".",
          decimal: ",",
          grouping: 3
        },
        'NOK': {
          string: "kr.",
          format: "%s %s",
          atEnd: true,
          precision: 2,
          thousands: ".",
          decimal: ",",
          grouping: 3
        },
        'SEK': {
          string: "kr.",
          format: "%s %s",
          atEnd: true,
          precision: 2,
          thousands: ".",
          decimal: ",",
          grouping: 3
        },
        'DKK': {
          string: "kr.",
          format: "%s %s",
          atEnd: true,
          precision: 2,
          thousands: ".",
          decimal: ",",
          grouping: 3
        },
        'GBP': {
          string: "£",
          format: "%s%s",
          atEnd: false,
          precision: 2,
          thousands: ".",
          decimal: ".",
          grouping: 3
        }
      });
      scope.kScope.currency.mergeToGlobal();
    },
    addTranslations: function (data, scope) {
      var translator = klevu.search[window.pageType].getScope().template.getTranslator();

      if (typeof klevu_lang === "undefined") klevu_lang = "en";

      for (const key in klevu_storeTranslationsKeys) {
        if (typeof locale_translations !== 'undefined' && typeof locale_translations !== 'undefined') {
          translator.addTranslation(klevu_storeTranslationsKeys[key], locale_translations[key]);
        }
      }
      translator.mergeToGlobal();
    },
    filterTags: {
      base: {
        init: function (scope) {
          var template = scope.data.template;
          if (template.query) {
            template.filterTags.query = {};
            klevu.each(template.query, function (key, value) {
              var filterData = {
                tags: [],
              };
              if (value.filters) {
                klevu.each(value.filters, function (key, filter) {
                  var tag = {
                    key: filter.key,
                    label: filter.label,
                    values: [],
                  };
                  var isAnyFilterSelected = false;
                  if (filter.options) {
                    klevu.each(filter.options, function (key, option) {
                      if (option.selected) {
                        isAnyFilterSelected = true;
                        tag.values.push(option.name);
                      }
                    });
                  }
                  if (filter.type == "SLIDER") {
                    if (filter.start !== null && filter.end !== null) {
                      if (
                        Number(filter.start) !== Number(filter.min) ||
                        Number(filter.end) !== Number(filter.max)
                      ) {

                        var currSymbol = "";
                        var currSymbolAtEnd = false;
                        var productListResults = klevu.getObjectPath(scope.data, "template.query.productList.result");
                        if (
                          typeof klevu.search.modules.kmcInputs.base.getPriceFormatterObject == "function" &&
                          productListResults && productListResults.length
                        ) {
                          var currencyFormatter = klevu.search[window.pageType].getScope().currency.getCurrencys()[scope.data.template.query.productList.result[0].currency];

                          if (currencyFormatter) {
                            currSymbol = currencyFormatter.string;
                            var currSymbolHtml = document.createElement("textarea");
                            currSymbolHtml.innerHTML = currSymbol;
                            currSymbol = currSymbolHtml.value;
                            scope.recentCurrencySymbol = currSymbol;
                            currSymbolAtEnd = currencyFormatter.atEnd ?
                              currencyFormatter.atEnd :
                              false;
                          }
                        } else {
                          if (currSymbol == "" && typeof scope.recentCurrencySymbol != "undefined" && scope.recentCurrencySymbol) {
                            currSymbol = scope.recentCurrencySymbol;
                          }
                        }

                        if (currSymbolAtEnd) {
                          tag.values.push(filter.start + currSymbol + " - " + filter.end + currSymbol);
                        } else {
                          tag.values.push(currSymbol + filter.start + " - " + currSymbol + filter.end);
                        }
                        //tag.values.push("$" + filter.start + " - " + filter.end);
                        tag.key = "price";
                        tag.label = "price";
                        isAnyFilterSelected = true;
                      }
                    }
                  }
                  if (isAnyFilterSelected) {
                    filterData.tags.push(tag);
                  }
                });
              }
              template.filterTags.query[key] = filterData;
            });
          }
        },
        attachEvents: function (scope) {
          klevu.each(klevu.dom.find(".kuFilterTagClearAll"), function (key, element) {
            klevu.event.attach(element, "click", function (event) {
              var target = klevu.dom.helpers.getClosest(this, ".klevuTarget");
              if (target === null) {
                return;
              }
              var options = klevu.dom.helpers.getClosest(this, ".klevuMeta");
              if (options === null) {
                return;
              }
              var elScope = target.kElem;
              elScope.kScope.data = elScope.kObject.resetData(elScope.kElem);
              elScope.kScope.data.context.keyCode = 0;
              elScope.kScope.data.context.eventObject = event;
              elScope.kScope.data.context.event = "keyUp";
              elScope.kScope.data.context.preventDefault = false;

              klevu.setObjectPath(
                elScope.kScope.data,
                "localOverrides.query." +
                options.dataset.section +
                ".settings.offset",
                0
              );
              klevu.setObjectPath(
                elScope.kScope.data,
                "localOverrides.query." +
                options.dataset.section +
                ".filters.applyFilters", {}
              );
              klevu.event.fireChain(
                elScope.kScope,
                "chains.events.keyUp",
                elScope,
                elScope.kScope.data,
                event
              );
            });
          });
          klevu.each(klevu.dom.find(".kuFilterTagValue"), function (key, element) {
            klevu.event.attach(element, "click", function (e) {
              var kuFilterTag = klevu.dom.helpers.getClosest(element, ".kuFilterTag");
              var parentKeyValue =
                kuFilterTag && kuFilterTag.dataset.key ?
                  kuFilterTag.dataset.key :
                  undefined;

              if (parentKeyValue) {
                if (parentKeyValue == "price") {
                  var target = klevu.dom.helpers.getClosest(this, ".klevuTarget");
                  if (target === null) {
                    return;
                  }
                  var options = klevu.dom.helpers.getClosest(this, ".klevuMeta");
                  if (options === null) {
                    return;
                  }
                  var elScope = target.kElem;
                  elScope.kScope.data = elScope.kObject.resetData(elScope.kElem);
                  elScope.kScope.data.context.keyCode = 0;
                  elScope.kScope.data.context.eventObject = e;
                  elScope.kScope.data.context.event = "keyUp";
                  elScope.kScope.data.context.preventDefault = false;

                  var filterArray = Array.from(
                    klevu.search[window.pageType].getScope().data.localOverrides.query
                      .productList.filters.applyFilters.filters
                  );
                  var index = filterArray
                    .map(function (obj) {
                      return obj.key;
                    })
                    .indexOf("klevu_price");
                  filterArray.splice(index, 1);

                  klevu.setObjectPath(
                    elScope.kScope.data,
                    "localOverrides.query." +
                    options.dataset.section +
                    ".settings.offset",
                    0
                  );
                  klevu.setObjectPath(
                    elScope.kScope.data,
                    "localOverrides.query." +
                    options.dataset.section +
                    ".filters.applyFilters.filters",
                    filterArray
                  );
                  klevu.event.fireChain(
                    elScope.kScope,
                    "chains.events.keyUp",
                    elScope,
                    elScope.kScope.data,
                    e
                  );
                }

                var target = klevu.getSetting(
                  scope.settings,
                  "settings.search.searchBoxTarget"
                );
                klevu.each(
                  klevu.dom.find(".kuFilterBox", target),
                  function (key, value) {
                    var filterKey =
                      value.dataset && value.dataset.filter ?
                        value.dataset.filter :
                        undefined;
                    if (parentKeyValue == filterKey) {
                      klevu.each(
                        klevu.dom.find(".klevuFilterOption", value),
                        function (key, option) {
                          var optionValue =
                            option.dataset && option.dataset.value ?
                              option.dataset.value :
                              undefined;
                          var selectedOptionValue =
                            element.dataset && element.dataset.value ?
                              element.dataset.value :
                              undefined;
                          if (
                            optionValue &&
                            optionValue == selectedOptionValue
                          ) {
                            option.click();
                          }
                        }
                      );
                    }
                  }
                );
              }
            });
          });
        },
      },
      build: true,
    },

    addParamsToURL: {
      base: {
        addURLtoHistory: function (data, scope, queryId) {
          // Global stuff
          if (typeof window.history === "undefined" || typeof window.history.pushState === "undefined") {
            console.error("This browser does not have the support of window.history or window.history.pushState");
            return;
          }

          var searchPath = new URLSearchParams(window.location.search);
          var currentSearchPath;
          var previousSearchPath = searchPath.toString();

          // this is in case we're running our code where we dont have context.activeQueryId
          var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
          if (queryId && queryId.length) {
            activeQueryId = queryId;
          }

          // Check if there any filter selected
          let applyFilters = typeof data.localOverrides.query[activeQueryId].filters !== 'undefined' ? data.localOverrides.query[activeQueryId].filters.applyFilters : {};
          let isThereFiltersSelected = false;
          // Check if applyFilters is an object (but not an array), and not empty
          if (typeof applyFilters === 'object' && !Array.isArray(applyFilters) && applyFilters !== null && Object.keys(applyFilters).length > 0) {
            isThereFiltersSelected = true;
          }

          // Added by FlyingTiger - FTC-2373-2 - PAGINATION TO URL
          var hasPaginationEnabled = klevu.getSetting(klevu, "settings.theme.modules.pagination.searchResultsPage.enable");
          var paginationQueryParam = "Page";
          var currentPage = 0;

          if (hasPaginationEnabled) {
            var activeQueryMeta = klevu.getObjectPath(data, "template.query." + activeQueryId + ".meta");
            if (activeQueryMeta) {
              var productListLimit = activeQueryMeta.noOfResults;
              currentPage = Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
            }

            if (currentPage === 0 || currentPage === 1) {
              searchPath.delete(paginationQueryParam);
            } else {
              searchPath.set(paginationQueryParam, currentPage);
            }

            currentSearchPath = searchPath.toString();
          };

          // FILTERS TO URL
          var activeQueryFilters = klevu.getObjectPath(data, "template.query." + activeQueryId + ".filters");
          var filterValuesQueryParam = "";

          if (activeQueryFilters) {
            klevu.each(activeQueryFilters, function (key, filter) {
              var selectedFilterKeyString = "";
              var filterOptions = filter.options;
              var selectedValues = "";

              if (filterOptions && filterOptions.length) {
                klevu.each(filterOptions, function (key, option) {
                  if (option.selected === true) {
                    if (selectedValues.length) {
                      selectedValues += ",";
                    }
                    selectedValues += option.value;
                  }
                });
              } else if (filter.type === "SLIDER") {
                var startValue = filter.start;
                var endValue = filter.end;
                var minValue = filter.min;
                var maxValue = filter.max;
                if (typeof startValue !== "undefined" && startValue !== null && typeof endValue !== "undefined" && endValue !== null) {
                  if (Number(startValue) === Number(minValue) && Number(endValue) === Number(maxValue)) {
                    // just skipping
                  } else {
                    selectedValues = startValue + "-" + endValue;
                  }
                }
              }

              if (selectedValues.length) {
                // selectedFilterKeyString += filter.key + ":" + selectedValues;
                selectedFilterKeyString += encodeURIComponent(filter.key) + ":" + encodeURIComponent(selectedValues);
              }

              if (selectedFilterKeyString.length) {
                if (filterValuesQueryParam.length) {
                  filterValuesQueryParam += ";";
                }
                filterValuesQueryParam += selectedFilterKeyString;
              }
            });
          }

          if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
            searchPath.set("Filters", filterValuesQueryParam);
          } else {
            searchPath.delete("Filters");
          }

          currentSearchPath = searchPath.toString();

          // ==============================
          // Final URL change
          if (previousSearchPath !== currentSearchPath) {
            var historyState = { page: currentPage, filters: currentSearchPath };
            window.history.pushState(historyState, null, currentSearchPath ? '?' + currentSearchPath : window.location.pathname);
          }
        },

        restoreSearchParamsOnPageLoad: function (data, scope) {
          var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered");
          if (hasAlreadyTriggered) return;

          // var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
          var activeQueryId = "productList";
          var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
          var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");

          var matchedQueryParamId = "";
          var matchedQueryParamValue = "";
          var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries");

          if (recordQueries && recordQueries.length) {
            klevu.each(recordQueries, function (key, recordQuery) {
              if (recordQuery.id) {
                if ((paginationFromURL && paginationFromURL.length) || (filtersFromURL && filtersFromURL.length)) {
                  matchedQueryParamId = recordQuery.id;
                  matchedQueryParamValue = paginationFromURL || filtersFromURL;
                }
              }
            });
          }

          klevu.setObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered", true);

          matchedQueryParamId = "productList";

          if (matchedQueryParamId.length && matchedQueryParamValue.length) {
            activeQueryId = matchedQueryParamId;
            var storage = klevu.getSetting(scope.kScope.settings, "settings.storage");
            if (storage.tabs) {
              storage.tabs.setStorage("local");
              storage.tabs.mergeFromGlobal();
              storage.tabs.addElement("active", activeQueryId);
              storage.tabs.mergeToGlobal();
            }
          }

          if (paginationFromURL && paginationFromURL > 1) {
            if (recordQueries && recordQueries.length) {
              klevu.each(recordQueries, function (key, recordQuery) {
                if (recordQuery.id === activeQueryId) {
                  var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                  limit = Number(limit);
                  if (limit > 0) {
                    var expectedOffset = (paginationFromURL - 1) * limit;
                    klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                  }
                }
              });
            }
          }

          // FILTERS
          if (filtersFromURL && filtersFromURL.length) {
            var facets = filtersFromURL.split(";");
            if (facets) {
              klevu.each(facets, function (key, facet) {
                var splitFacet = facet.split(":");
                if (splitFacet.length) {
                  var facetKey = decodeURIComponent(splitFacet[0]);
                  var facetValues = decodeURIComponent(splitFacet[1]).split(",");
                  var applyFilters = klevu.getObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters");

                  if (applyFilters && applyFilters.length) { // if there're some filters
                    var isExistingKey = false;
                    klevu.each(applyFilters, function (key, applyFilter) {
                      if (applyFilter.key === facetKey) {
                        isExistingKey = true;
                        klevu.each(facetValues, function (key, facetValue) {
                          var isFilterOptionMatched = false;
                          klevu.each(applyFilter.values, function (key, value) {
                            if (facetValue === value) {
                              isFilterOptionMatched = true;
                            }
                          });
                          if (!isFilterOptionMatched) {
                            applyFilter.values.push(facetValue);
                          }
                        });
                      }
                    });
                    if (!isExistingKey) {
                      applyFilters.push({ key: facetKey, values: facetValues });
                    }
                  } else {
                    klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", [{ key: facetKey, values: facetValues }]);
                  }

                }
              });
            }
          }
        },

        updatePayloadOnPopState: function (data, scope, activeQueryId) {
          // SET PAGINATION PAYLOAD
          var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");
          paginationFromURL = Number(paginationFromURL);
          var limit = klevu.search[window.pageType].getScope().element.kObject.getScope().data.request.original.queryRequest[0].settings.limit;
          limit = Number(limit);
          if (limit > 0) {
            var expectedOffset = ((paginationFromURL - 1) * limit) > 0 ? ((paginationFromURL - 1) * limit) : 0;
            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
            // klevu.search.modules.addParamsToURL.base.backBtnCounter.backBtn = 0;
          }

          // SET FILTER PAYLOAD
          var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
          if (filtersFromURL && filtersFromURL.length) {
            var facets = filtersFromURL.split(";");
            // loop through all facets to get its values
            let facetKey = '';
            let facetValues = [];
            let facetsArray = [];

            klevu.each(facets, function (key, facet) {
              var splitFacet = facet.split(":");
              if (splitFacet.length) {
                facetKey = decodeURIComponent(splitFacet[0]);
                facetValues = decodeURIComponent(splitFacet[1]).split(",");
                facetsArray.push({ key: facetKey, values: facetValues });
              }
            });
            // set the payload with correct filters:
            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", facetsArray);
          } else { // reset filters if Back button pressed, and there's no filters
            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
          }
        }
      },
      build: true
    }

  });
})(klevu);

(function (klevu) {
  /**
   * Function to initialize slider
   * @param {*} data
   * @param {*} scope
   */
  var regex = /[+-]?\d+(?:\.\d+)?/;

  function initSlider(data, scope) {
    var self = this;
    var target = klevu.getSetting(scope.settings, "settings.search.searchBoxTarget");
    var priceSliderList = klevu.dom.find(".kuPriceSlider [data-querykey]", target);
    if (priceSliderList) {
      priceSliderList.forEach(function (ele) {
        var sliderData;
        var querykey = ele.getAttribute("data-querykey");
        var contentData = data.template.query[querykey];
        if (contentData) {
          contentData.filters.forEach(function (filter) {
            if (
              filter.key == scope.priceSliderFilterReqQuery.key &&
              filter.type == "SLIDER"
            ) {
              sliderData = filter;
            }
          });
        }
        if (sliderData) {
          var currSymbol = "";
          var currSymbolAtEnd = false;
          var productListResults = klevu.getObjectPath(scope.data, "template.query.productList.result");
          if (
            typeof klevu.search.modules.kmcInputs.base.getPriceFormatterObject == "function" &&
            productListResults && productListResults.length
          ) {
            var currencyFormatter = klevu.search[window.pageType].getScope().currency.getCurrencys()[scope.data.template.query.productList.result[0].currency];
            if (currencyFormatter) {
              currSymbol = currencyFormatter.string;
              var currSymbolHtml = document.createElement("textarea");
              currSymbolHtml.innerHTML = currSymbol;
              currSymbol = currSymbolHtml.value;
              scope.recentCurrencySymbol = currSymbol;
              currSymbolAtEnd = currencyFormatter.atEnd ?
                currencyFormatter.atEnd :
                false;
            }
          } else {
            if (currSymbol == "" && typeof scope.recentCurrencySymbol != "undefined" && scope.recentCurrencySymbol) {
              currSymbol = scope.recentCurrencySymbol;
            }
          }

          var formatObj = {};
          if (currSymbolAtEnd === true) {
            formatObj.suffix = " " + currSymbol;
          } else if (currSymbolAtEnd === false) {
            formatObj.prefix = currSymbol + " ";
          }
          formatObj.decimals = 0;
          if (ele.slider) {
            ele.slider.destroy();
          }
          ele.sliderData = sliderData;
          if (sliderData.start === undefined || sliderData.start == null) {
            sliderData.start = sliderData.min;
          }
          if (sliderData.end === undefined || sliderData.end == null) {
            sliderData.end = sliderData.max;
          }
          ele.slider = noUiSlider.create(ele, {
            start: [Math.floor(sliderData.start), Math.ceil(sliderData.end)],
            connect: true,
            tooltips: [true, true],
            range: {
              min: [Math.floor(sliderData.min)],
              max: [Math.ceil(sliderData.max)],
            },
            format: wNumb(formatObj),
          });
          var isLeftScroll = false;
          var toolTipMergePointValue = (Math.ceil(sliderData.max) - Math.ceil(sliderData.min)) / 2;

          ele.slider.on("update", function (values, handle, intValues) {
            isLeftScroll = (handle === 0) ? true : false;
            var leftNodeValue = intValues[0];
            var leftNodeTooltip = klevu.dom.find(".noUi-handle-lower .noUi-tooltip", ele)[0];
            leftNodeTooltip.textContent = this.get()[0];
            leftNodeTooltip.style.display = "";
            leftNodeTooltip.classList.remove("kuMergedTooltip");

            var rightNodeValue = intValues[1];
            var rightNodeTooltip = klevu.dom.find(".noUi-handle-upper .noUi-tooltip", ele)[0];
            rightNodeTooltip.textContent = this.get()[1];
            rightNodeTooltip.style.display = "";
            rightNodeTooltip.classList.remove("kuMergedTooltip");

            if ((rightNodeValue - leftNodeValue) <= toolTipMergePointValue) {
              var targetTooltip = (isLeftScroll) ? rightNodeTooltip : leftNodeTooltip;
              var leftNodeDiff = intValues[0] - Math.ceil(sliderData.min);
              var rightNodeDiff = Math.ceil(sliderData.max) - intValues[1];
              if (leftNodeDiff > rightNodeDiff) {
                targetTooltip = rightNodeTooltip;
                leftNodeTooltip.style.display = "none";
              } else {
                targetTooltip = leftNodeTooltip;
                rightNodeTooltip.style.display = "none";
              }
              if ((rightNodeValue - leftNodeValue) === 0) {
                targetTooltip.textContent = this.get()[1];
              } else {
                targetTooltip.textContent = this.get().join(" - ");
                targetTooltip.classList.add("kuMergedTooltip");
              }
            }
          });
          ele.slider.on("change", function (values, handle) {
            self.sliderOnUpdateEvent(values, querykey, data, ele, scope);
          });
        }
      });
    }
  }

  /**
   * Slider filter on value change event
   * @param {*} values
   * @param {*} querykey
   * @param {*} data
   * @param {*} ele
   */
  function sliderOnUpdateEvent(values, querykey, data, ele, scope) {
    var min = Math.ceil(regex.exec(values[0])[0]);
    var max = Math.ceil(regex.exec(values[1])[0]);

    var target = klevu.getSetting(scope.settings, "settings.search.searchBoxTarget");

    /** Get Scope */
    var sliderFilter = klevu.dom.helpers.getClosest(
      klevu.dom.find(".klevuSliderFilter", target)[0],
      ".klevuTarget"
    );

    var elScope = sliderFilter.kElem;
    elScope.kScope.data = elScope.kObject.resetData(elScope.kElem);

    var options = klevu.dom.helpers.getClosest(
      klevu.dom.find(".klevuSliderFilter", target)[0],
      ".klevuMeta"
    );

    var localQuery = data.localOverrides.query[querykey];
    var localFilters = localQuery.filters;
    var sliderFilterReqObj = {
      key: ele.sliderData.key,
      settings: {
        singleSelect: "false",
      },
      values: [min.toString(), max.toString()],
    };
    if (!localFilters) {
      localQuery.filters = {};
      localQuery.filters.applyFilters = {};
      localQuery.filters.applyFilters.filters = [sliderFilterReqObj];
    } else {
      var applyFilters = localFilters.applyFilters.filters;
      var isUpdated = false;
      if (applyFilters) {
        applyFilters.forEach(function (filter) {
          if (filter.key == ele.sliderData.key) {
            isUpdated = true;
            filter.values = [min.toString(), max.toString()];
          }
        });
        if (!isUpdated) {
          applyFilters.push(sliderFilterReqObj);
        }
      } else {
        localQuery.filters.applyFilters.filters = [sliderFilterReqObj];
      }
    }

    /** reset offset after filter change */
    klevu.setObjectPath(
      elScope.kScope.data,
      "localOverrides.query." + options.dataset.section + ".settings.offset",
      0
    );
    klevu.event.fireChain(
      elScope.kScope,
      "chains.events.keyUp",
      elScope,
      elScope.kScope.data,
      event
    );
  }

  var filterPriceSlider = {
    initSlider: initSlider,
    sliderOnUpdateEvent: sliderOnUpdateEvent,
  };

  klevu.extend(true, klevu.search.modules, {
    filterPriceSlider: {
      base: filterPriceSlider,
      build: true,
    },
  });
})(klevu);

// FTC-2443 - Added by flyingtiger to reset the sort order on page reload - 18/9/23
window.addEventListener('DOMContentLoaded', function () {
  localStorage.setItem('klv_sort_productList', 'RELEVANCE');
}, true);

const facetsColors = {
  multi: ['Multi', 'Î Î¿Î»Ï…', 'KeliÅ³', 'Wielo', 'Ã‡ok'],
  white: ['White', 'Hvid', 'BÃ­lÃ½', 'Wit', 'Valge', 'Valkoinen', 'Blanc', 'WeiÃŸ', 'Î†ÏƒÏ€ÏÎ¿Ï‚', 'FehÃ©r', 'Bianco', 'Balts', 'Baltas', 'Hvit', 'BiaÅ‚y', 'Alb', 'Biely', 'Blanco', 'Vit', 'Beyaz', 'Branco'],
  black: ['Black', 'Sort', 'ÄŒernÃ½', 'Zwart', 'Must', 'Musta', 'Noir', 'Schwarz', 'ÎœÎ±ÏÏÎ¿Ï‚', 'Fekete', 'Nero', 'Melns', 'Juodas', 'Svart', 'Czarny', 'Negru', 'ÄŒierny', 'Negro', 'Siyah', 'Preto'],
  brown: ['Brown', 'Brun', 'HnÄ›dÃ½', 'Bruin', 'Pruun', 'Ruskea', 'Marron', 'Braun', 'ÎšÎ±Ï†Î­', 'Barna', 'Marrone', 'BrÅ«ns', 'Rudas', 'BrÄ…zowy', 'HnedÃ½', 'MarrÃ³n', 'Kahverengi', 'Castanho'],
  blue: ['Blue', 'BlÃ¥', 'ModrÃ½', 'Blauw', 'Sinine', 'Sininen', 'Bleu', 'Blau', 'ÎœÏ€Î»Îµ', 'KÃ©k', 'Blu', 'Zils', 'MÄ—lynas', 'Niebieski', 'Albastru', 'Azul', 'Mavi'],
  green: ['Green', 'GrÃ¸n', 'ZelenÃ½', 'Groen', 'Roheline', 'VihreÃ¤', 'Vert', 'GrÃ¼n', 'Î ÏÎ¬ÏƒÎ¹Î½Î¿Ï‚', 'ZÃ¶ld', 'Verde', 'ZaÄ¼Å¡', 'Å½alias', 'GrÃ¸nn', 'Zielony', 'GrÃ¶n', 'YeÅŸil'],
  red: ['Red', 'RÃ¸d', 'ÄŒervenÃ½', 'Rood', 'Punane', 'Punainen', 'Rouge', 'Rot', 'ÎšÏŒÎºÎºÎ¹Î½Î¿Ï‚', 'Piros', 'Rosso', 'Sarkans', 'Raudonas', 'Czerwony', 'RoÈ™u', 'Rojo', 'RÃ¶d', 'KÄ±rmÄ±zÄ±', 'Vermelho'],
  purple: ['Purple', 'Lilla', 'NachovÃ½', 'Paars', 'Purpurne', 'Purppura', 'Pourpre', 'Lila', 'ÎœÎ¿Î²', 'Porpora', 'LillÄ', 'VioletinÄ—', 'Purpura', 'Purpuriu', 'PurpurovÃ½', 'Morado', 'Mor', 'Roxo'],
  pink: ['Pink', 'LyserÃ¸d', 'RÅ¯Å¾ovÃ½', 'Roze', 'Roosa', 'Vaaleanpunainen', 'Rose', 'Rosa', 'Î¡Î¿Î¶', 'RÃ³zsaszÃ­n', 'RozÄ', 'RoÅ¾inis', 'RÃ³Å¼owy', 'Roz', 'RuÅ¾ovÃ½', 'Rosado', 'Pembe'],
  yellow: ['Yellow', 'Gul', 'Å½lutÃ½', 'Geel', 'Kollane', 'Keltainen', 'Jaune', 'Gelb', 'ÎšÎ¯Ï„ÏÎ¹Î½Î¿Ï‚', 'SÃ¡rga', 'Giallo', 'Dzeltens', 'Geltonas', 'Å»Ã³Å‚ty', 'Galben', 'Å½ltÃ½', 'Amarillo', 'SarÄ±', 'Amarelo'],
  silver: ['Silver', 'SÃ¸lv', 'StÅ™Ã­bro', 'Zilver', 'HÃµbe', 'Hopea', 'Argent', 'Silber', 'Î‘ÏƒÎ®Î¼Î¹', 'EzÃ¼st', 'Argento', 'Sudrabs', 'Sidabras', 'Srebro', 'Argint', 'Striebro', 'Plata', 'GÃ¼mÃ¼ÅŸ', 'Prata'],
  gray: ['Gray', 'GrÃ¥', 'Å edÃ½', 'Grijs', 'Hall', 'Harmaa', 'Gris', 'Grau', 'Î“ÎºÏÎ¯Î¶Î¿Ï‚', 'SzÃ¼rke', 'Grigio', 'PelÄ“ks', 'Pilka', 'Szary', 'Gri', 'SivÃ½', 'Cinza'],
  orange: ['Orange', 'Appelsin', 'PomeranÄ', 'Oranje', 'Apelsin', 'Appelsiini', 'Î Î¿ÏÏ„Î¿ÎºÎ¬Î»Î¹', 'Narancs', 'Arancia', 'PelÄ“ks', 'OranÅ¾s', 'Apelsinas', 'PomaraÅ„cza', 'PortocalÄƒ', 'OranÅ¾ovÃ½', 'Naranja', 'Portakal', 'Laranja'],
  beige: ['Beige', 'Beige', 'BÃ©Å¾ovÃ½', 'Apelsin', 'BeeÅ¾', 'ÎœÏ€ÎµÎ¶', 'BÃ©zs', 'BÄ“Å¡s', 'SmÄ—lio spalva', 'BeÅ¼', 'Bej', 'Bege'],
  gold: ['Gold', 'Guld', 'Zlato', 'Goud', 'Kuld', 'Kulta', 'Or', 'Î§ÏÏ…ÏƒÏŒÏ‚', 'Arany', 'Oro', 'Zelts', 'Auksas', 'Gull', 'ZÅ‚oto', 'Aur', 'AltÄ±n', 'Ouro']
}

//var klevuTranslaton = ["Limited edition", "Quick view", "Add to bag", "Clear", "Clear all","Refined by", "Filters", "Last chance", "Product of the week"]

var klevu_storeTranslationsKeys = {
  "limited_edition": "Limited edition",
  "quick_view": "Quick view",
  "add_to_cart": "Add to bag",
  "clear": "Clear",
  "clear_all": "Clear all",
  "refined_by": "Refined by",
  // "Filters": "Filtros",
  "last_chance": "Last chance",
  "product_of_the_week": "Product of the week",
}


//Added by FlyingTiger - FTC-2373-2 - Number of products showing template
const klevuLandingResultsShowingCustom = `<% if(data.query[dataLocal].result.length > 0 ) { %>
    <%
      var resultsPerPage = data.query[dataLocal].meta.noOfResults;
      const currentOffset = data.query[dataLocal].meta.offset;
      const productListLimit = data.query.productList.meta.noOfResults;
      const currentPage = (Math.ceil(currentOffset / resultsPerPage) + 1);
      const productListTotal = data.query.productList.meta.totalResultsFound;
      const lastPage = (Math.ceil(productListTotal / productListLimit) - currentPage) >= 1 ? (Math.ceil(productListTotal / productListLimit)) : 0;
      const toProducts = data.query.productList.meta.offset + productListLimit >= productListTotal ? productListTotal : data.query.productList.meta.offset + productListLimit;
  
      const showFromProducts = currentPage <= 1 ? 1 : (productListLimit * (currentPage - 1)+1);
  
      const showFromText = (lastPage === 0 && productListTotal === 0) ? productListTotal : showFromProducts;
    %>
  
    <div class="ku-landing-total-results-title klevu-pagination">
      <div class="page-total">
      <span>Showing</span>
        <% if(showFromProducts !== toProducts) { %>
          <span class="from"><%= showFromText %></span><span>-</span><span class="to"><%= toProducts %></span>
        <% } else { %>
          <span class="from"><%= showFromText %></span>
          <% } %>
          <span>of</span>
          <span><%= productListTotal %></span>
          <span>total</span>
      </div>
    </div>
  <% } %>`;
var klevuLandingTemplateFiltersCustom = `
<%
const facetsColors = {
  multi: ['Multi', 'Πολυ', 'Kelių', 'Wielo', 'Çok'],
  white: ['White', 'Hvid', 'Bílý', 'Wit', 'Valge', 'Valkoinen', 'Blanc', 'Weiß', 'Άσπρος', 'Fehér', 'Bianco', 'Balts', 'Baltas', 'Hvit', 'Biały', 'Alb', 'Biely', 'Blanco', 'Vit', 'Beyaz','Branco'],
  black: ['Black', 'Sort', 'Černý', 'Zwart', 'Must', 'Musta', 'Noir', 'Schwarz', 'Μαύρος', 'Fekete', 'Nero', 'Melns', 'Juodas', 'Svart', 'Czarny', 'Negru', 'Čierny', 'Negro', 'Siyah','Preto'],
  brown: ['Brown', 'Brun', 'Hnědý', 'Bruin', 'Pruun', 'Ruskea', 'Marron', 'Braun', 'Καφέ', 'Barna', 'Marrone', 'Brūns', 'Rudas', 'Brązowy', 'Hnedý', 'Marrón', 'Kahverengi','Castanho'],
  blue: ['Blue', 'Blå', 'Modrý', 'Blauw', 'Sinine', 'Sininen', 'Bleu', 'Blau', 'Μπλε', 'Kék', 'Blu', 'Zils', 'Mėlynas', 'Niebieski', 'Albastru', 'Azul', 'Mavi'],
  green: ['Green', 'Grøn', 'Zelený', 'Groen', 'Roheline', 'Vihreä', 'Vert', 'Grün', 'Πράσινος', 'Zöld', 'Verde', 'Zaļš', 'Žalias', 'Grønn', 'Zielony', 'Grön', 'Yeşil'],
  red: ['Red', 'Rød', 'Červený', 'Rood', 'Punane', 'Punainen', 'Rouge', 'Rot', 'Κόκκινος', 'Piros', 'Rosso', 'Sarkans', 'Raudonas', 'Czerwony', 'Roșu','Rojo','Röd','Kırmızı','Vermelho'],
  purple: ['Purple', 'Lilla', 'Nachový', 'Paars', 'Purpurne', 'Purppura', 'Pourpre', 'Lila', 'Μοβ', 'Porpora', 'Lillā', 'Violetinė', 'Purpura', 'Purpuriu', 'Purpurový','Morado','Mor','Roxo'],
  pink: ['Pink', 'Lyserød', 'Růžový', 'Roze', 'Roosa', 'Vaaleanpunainen', 'Rose', 'Rosa', 'Ροζ', 'Rózsaszín', 'Rozā', 'Rožinis', 'Różowy', 'Roz', 'Ružový','Rosado','Pembe'],
  yellow: ['Yellow', 'Gul', 'Žlutý', 'Geel', 'Kollane', 'Keltainen', 'Jaune', 'Gelb', 'Κίτρινος', 'Sárga', 'Giallo', 'Dzeltens', 'Geltonas', 'Żółty', 'Galben','Žltý','Amarillo','Sarı', 'Amarelo'],
  silver: ['Silver', 'Sølv', 'Stříbro', 'Zilver', 'Hõbe', 'Hopea', 'Argent', 'Silber', 'Ασήμι', 'Ezüst', 'Argento', 'Sudrabs', 'Sidabras', 'Srebro', 'Argint','Striebro','Plata','Gümüş','Prata'],
  grey: ['Grey', 'Grå', 'Šedý', 'Grijs', 'Hall', 'Harmaa', 'Gris', 'Grau', 'Γκρίζος', 'Szürke', 'Grigio', 'Pelēks', 'Pilka', 'Szary', 'Gri', 'Sivý','Cinza'],
  orange: ['Orange', 'Appelsin', 'Pomeranč', 'Oranje', 'Apelsin', 'Appelsiini', 'Πορτοκάλι', 'Narancs', 'Arancia', 'Pelēks', 'Oranžs', 'Apelsinas', 'Pomarańcza', 'Portocală','Oranžový','Naranja','Portakal','Laranja'],
  beige: ['Beige', 'Beige', 'Béžový', 'Apelsin', 'Beež', 'Μπεζ', 'Bézs', 'Bēšs', 'Smėlio spalva', 'Beż', 'Bej','Bege'],
  gold: ['Gold', 'Guld', 'Zlato', 'Goud', 'Kuld', 'Kulta', 'Or', 'Χρυσός', 'Arany', 'Oro', 'Zelts', 'Auksas', 'Gull', 'Złoto', 'Aur', 'Altın','Ouro']
}
%>
<% if(data.query[dataLocal].filters.length > 0 ) { %>
  <div class="drawer__overlay klevu_overlay"></div>
  <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">
  <button class="kuFilterClose"></button>

    <div class="klevu-filters-mobile mobile_only">
      <% 
          var filterTagsModule = data.filterTags;
          var filterTagsData = [];
          if(dataLocal && dataLocal.length){
              filterTagsData = filterTagsModule.query[dataLocal].tags;
          }
      %>
      <% if(filterTagsData.length) { %>
        <div class="kuFilterTagsWrapper">
              <span class="ku-kuFilterTagsLabel"><%=helper.translate("Refined by") %></span>
              <span title="<%=helper.translate("Clear all") %>" class="kuFilterTagClearAll"><%= helper.translate("Clear all") %></span>
            </div> 
          <div class="kuFilterTagsContainer">

                  
              <% helper.each(filterTagsData, function(key,item){ 
                  var filterTagItemKey = item.key;
                  var filterTagItemLabel = helper.escapeHTML(helper.translate(item.label));
                  %>
                  <span class="kuFilterTag" data-key="<%= filterTagItemKey %>">
                      
                      <% if (filterTagItemKey.toLowerCase() !== "sustainable") { %>
                      <span 
                          title="<%= filterTagItemLabel %>" 
                          data-value="<%= filterTagItemLabel %>" 
                          class="kuFilterTagKey"
                      ><%= helper.translate(item.label).replace("£", "") %></span>
                      <% } %>

                      <% helper.each(item.values, function(key,option){ %>
                          <span 
                              title="<%= helper.escapeHTML(helper.translate(option)) %>" 
                              data-value="<%= helper.escapeHTML(helper.translate(option)) %>" 
                              class="kuFilterTagValue">
                              <% if (filterTagItemKey.toLowerCase() !== "sustainable") { %>
                                <%= helper.translate(option) %>
                              <% } else { %>
                                Eco-conscious only
                              <% } %>
                              <span>&times;</span>
                          </span>
                      <% }); %>
                  </span>
              <% }); %>
              
          </div>
      <% } %>
    </div>

      <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
          <% if(filter.type == "OPTIONS"){ %>
              <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
              
              <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                  <% if((filter.key === 'Sustainable' || filter.key === 'sustainable') && theme.settings.ecoconscious_enabled){ %>
                    <tool-tip class="tooltip eco-conscious">
                      <svg class="icon icon-eco-friendly" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><defs><style>.cls-1{fill:#228848;}</style></defs><path class="cls-1" d="M779.68,212.65,478.78,81.41,228,205.11,70.81,500.38,219.87,836.9,441.7,919.06H622.37L844.46,787.45l85.43-312.16Zm-532.19,12.6,97.05-47.86L384,190.68l-8.38,77.54h83.72l27.76-75.64L516.07,237V303.6l-84.59,36.13L365.7,365.05l-29.52,47.12H217.63l25.28,81.47,55.65,17.89,23.3,72.24,81.57-57.32,83.82,44v56.88h60l14.81,130.06H474.24l18.44,67.63-76.17,10.26-18.59-76.07V680L266.53,633.5l-26.76-93.68-49.32-53.26L166.33,377.74ZM615.05,892.36H446.49L239.72,815.78,100.49,501.45,147,414,166,499.4l49.9,53.89,28.79,100.78,126.58,44.79v63.61L396.28,865l130.19-17.52-17.28-63.33H592L571.1,600.67H514v-46.3L401.42,495.23l-65.27,45.86L319.77,490.3,264.3,472.47l-10.43-33.61H351l32.64-52.09,57.69-22.22,101.48-43.32V229.08l-62.34-95.7-39.7,108.14H405.39l7.49-69.3-34.39-11.57,101-49.81L760.9,233.59l91.92,160.72H732.47l-21.78-47.93L591.15,400.05l17.17,68.7L578.5,514.63l79.82,53.21H761.4l6.43,64.23L744.33,694l68.33,81.26Zm211.8-141.71-52-61.84L795,635.66l-9.45-94.52H666.41l-51.14-34.09L637,473.56l-14.57-58.3,74.91-33.64L715.28,421H866.82v-2.23l34.4,60.15Z"/></svg>
                      <div class="tooltip-wrapper">
                        <div class="icon-wrapper">
                          <svg class="icon icon-eco-friendly" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><defs><style>.cls-1{fill:#228848;}</style></defs><path class="cls-1" d="M779.68,212.65,478.78,81.41,228,205.11,70.81,500.38,219.87,836.9,441.7,919.06H622.37L844.46,787.45l85.43-312.16Zm-532.19,12.6,97.05-47.86L384,190.68l-8.38,77.54h83.72l27.76-75.64L516.07,237V303.6l-84.59,36.13L365.7,365.05l-29.52,47.12H217.63l25.28,81.47,55.65,17.89,23.3,72.24,81.57-57.32,83.82,44v56.88h60l14.81,130.06H474.24l18.44,67.63-76.17,10.26-18.59-76.07V680L266.53,633.5l-26.76-93.68-49.32-53.26L166.33,377.74ZM615.05,892.36H446.49L239.72,815.78,100.49,501.45,147,414,166,499.4l49.9,53.89,28.79,100.78,126.58,44.79v63.61L396.28,865l130.19-17.52-17.28-63.33H592L571.1,600.67H514v-46.3L401.42,495.23l-65.27,45.86L319.77,490.3,264.3,472.47l-10.43-33.61H351l32.64-52.09,57.69-22.22,101.48-43.32V229.08l-62.34-95.7-39.7,108.14H405.39l7.49-69.3-34.39-11.57,101-49.81L760.9,233.59l91.92,160.72H732.47l-21.78-47.93L591.15,400.05l17.17,68.7L578.5,514.63l79.82,53.21H761.4l6.43,64.23L744.33,694l68.33,81.26Zm211.8-141.71-52-61.84L795,635.66l-9.45-94.52H666.41l-51.14-34.09L637,473.56l-14.57-58.3,74.91-33.64L715.28,421H866.82v-2.23l34.4,60.15Z"/></svg>
                        </div>
                        <div class="content-wrapper">
                        <h6>Eco-conscious products</h6>
                        <p><p>We classify eco-conscious as: made from FSC-certified wood/paper material (min 95%) and/or made from recycled material (min. 80%) and/or made from renewable material (min. 95%) and/or made from easily recyclable materials (glass, aluminium, steel, or iron products with content &gt;= 95%). Each product is individually assessed by the sustainability department. <a href="/pages/planet" target="_blank" title="Planet"><span style="text-decoration:underline">Read more</span></a></p></p>
                        </div>
                      </div>
                    </tool-tip>
                  <% } %>
                      <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                      <span class="kuFacetLabel"><%=helper.translate(filter_label)%></span>
                      <% var renderButton = false; %>
                      <% helper.each(filter.options,function(key,option){ %>
                        <% if(option.selected ){
                            renderButton = true;
                         } %>
                      <% }); %>
                      <% if(renderButton){ %>
                        <button data-facet="<%=filter.key%>" class="ku-clearFacet"><%=helper.translate("Clear")%></button>
                      <% } %>
                  </div>
                  <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                      <ul>
                          <% helper.each(filter.options,function(key,filterOption){ %>
                            <% if((filter.key === 'Sustainable' || filter.key === 'sustainable') && theme.settings.ecoconscious_enabled){
                                filterOption.name = 'Eco-conscious only';
                            } %>
                              <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                  <a
                                      target="_self" 
                                      href="#" 
                                      title="<%=helper.escapeHTML(filterOption.name)%>" 
                                      class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                      data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                  >
                                  <% 
                                  let bgColor = '';
                                  for (const color in facetsColors) {
                                    if (facetsColors[color].indexOf(filterOption.value) !== -1) {
                                      bgColor = color;
                                      break;
                                    } 
                                  }
                                  
                                  %>
                                  
                                  <% if(bgColor === '') { %>
                                      <span class="kuFilterIcon"></span>
                                  <% } else { %>
                                    <%
                                    if(bgColor === 'multi'){
                                      bgColor = 'url(https://cdn.shopify.com/s/files/1/0520/8899/5991/t/19/assets/colour-multi.png?v=6222929237873657131)';
                                    }
                                    %>
                                      <span class="kuFilterIcon" style="background: <%=bgColor%>;"></span>
                                  <% } %>
                                      <span class="kufacet-text"><%=filterOption.name%></span>
                                      <% if(filterOption.selected ==true) { %>
                                          <span class="kuFilterCancel">X</span>
                                      <% } else { %>
                                          <span class="kuFilterTotal"><%=filterOption.count%></span>
                                      <% } %>
                                  </a>
                              </li>
                              
                          <%  }); %>
                      </ul>
                      <% if(filter.options.length > 5 ) { %>
                          <div class="kuShowOpt" tabindex="-1">
                              <span class="kuFilterDot"></span><span class="kuFilterDot"></span><span class="kuFilterDot"></span>
                          </div>
                      <% } %>
                  </div>
              </div>
          <% } else if(filter.type == "SLIDER")  { %>
            <div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                  <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                      <% var filter_label = (filter.label=="klevu_price") ? "Price range" : filter.label; %>
                      <span><%=helper.translate(filter_label)%></span>
                  </div>
                  <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">                           
          <div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
            <div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
          </div>
                  </div>
              </div>
          <% } else { %>
              <!-- Other Facets -->
          <% } %>
      <% }); %>
      
      <!-- <div class="kuFiltersFooter">
        <a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
  </div> -->
      
      
  </div>
<% } %>
`;
//Added by FlyingTiger FTC-2373-2- -Paginate custom template
var klevuLandingTemplatePaginationCustom = `
<% if(data.query[dataLocal].result.length > 0 ) { %>
    <% var productListLimit = data.query[dataLocal].meta.noOfResults; %>
    <% var productListTotal = data.query[dataLocal].meta.totalResultsFound - 1; %>
    <nav class="pagination-wrapper">
      <ul class="pagination__list list-unstyled">
          <% if(data.query[dataLocal].meta.offset > 0) { %>
            <li>
              <a target="_self" href="javascript:void(0)" class="klevuPaginate pagination__item pagination__item--next pagination__item-arrow link motion-reduce" data-offset="<%=(data.query[dataLocal].meta.offset-productListLimit)%>">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                  </path>
                </svg>
              </a>
            </li>
          <% } %>
          
          <% var currentPage = Math.ceil(data.query[dataLocal].meta.offset / productListLimit) + 1; %>
          
          <!-- Always Show First Page if current page is not 1 -->
          <% if (currentPage !== 1) { %>
            <li>
              <a target="_self" href="javascript:void(0)" class="klevuPaginate pagination__item link" data-offset="0">1</a>
            </li>
          <% } %>

          <% var lastPageOffset = Math.floor(productListTotal / productListLimit) * productListLimit; %>
          <% var currentPage = Math.floor(data.query[dataLocal].meta.offset / productListLimit) + 1; %>
          <% var lastPageNumber = Math.floor(productListTotal / productListLimit) + 1; %>
          
          <!-- Show Ellipsis Next to First Page -->
          <% if (currentPage > 4 && lastPageNumber > 4) { %>
            <li>
              <span class="pagination__item">...</span>
            </li>
            <% } %>

            <% if (data.query[dataLocal].meta.offset > productListLimit) { %>
              <% if ((Math.floor(data.query[dataLocal].meta.offset / productListLimit))-1 > 1) { %>
                <li>
                  <a target="_self" href="javascript:void(0)" class="klevuPaginate pagination__item link" data-offset="<%=(data.query[dataLocal].meta.offset - 2*productListLimit)%>"><%=(Math.ceil(data.query[dataLocal].meta.offset / productListLimit))-1%></a>
                </li>
              <% } %>
              <li>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate pagination__item link" data-offset="<%=(data.query[dataLocal].meta.offset - productListLimit)%>"><%=(Math.ceil(data.query[dataLocal].meta.offset / productListLimit))%></a>
              </li>
            <% } %>

          <li>
            <a href="javascript:void(0);" class="kuCurrent pagination__item pagination__item--current"><%=(Math.floor(data.query[dataLocal].meta.offset/productListLimit)+1)%></a>
          </li>

          <% if(productListTotal >= data.query[dataLocal].meta.offset+productListLimit && (Math.floor(data.query[dataLocal].meta.offset/productListLimit)+2) !==lastPageNumber) { %>
            <li>  
              <a target="_self" href="javascript:void(0)" class="1 klevuPaginate pagination__item link" data-offset="<%=(data.query[dataLocal].meta.offset+productListLimit)%>"><%=(Math.floor(data.query[dataLocal].meta.offset/productListLimit)+2)%></a>
            </li>
          <% } %>

          <% if(productListTotal >= data.query[dataLocal].meta.offset+2*productListLimit && (Math.floor(data.query[dataLocal].meta.offset/productListLimit)+3) !==lastPageNumber) { %>
            <li>  
              <a target="_self" href="javascript:void(0)" class="2 klevuPaginate pagination__item link" data-offset="<%=(data.query[dataLocal].meta.offset+2*productListLimit)%>"><%=(Math.floor(data.query[dataLocal].meta.offset/productListLimit)+3)%></a>
            </li>
          <% } %>

         
          <% var showEllipsis = (lastPageNumber - currentPage) >= 4; %>

          <!-- Show Ellipsis Before Last Page -->
          <% if (showEllipsis) { %>
            <li>
              <span class="pagination__item">...</span>
            </li>
          <% } %>

          <!-- Last Page Link -->
          <% var lastPageOffset = Math.floor(productListTotal / productListLimit) * productListLimit; %>
          <% if (lastPageOffset !== data.query[dataLocal].meta.offset) { %>
            <li>  
              <a target="_self" href="javascript:void(0)" class="klevuPaginate pagination__item link" data-offset="<%= lastPageOffset %>"><%= Math.floor(productListTotal / productListLimit) + 1 %></a>
            </li>
          <% } %>

          <% if(productListTotal >= data.query[dataLocal].meta.offset+productListLimit) { %>
            <li>  
              <a target="_self" href="javascript:void(0)" class="klevuPaginate pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" data-offset="<%=(data.query[dataLocal].meta.offset+productListLimit)%>">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                  </path>
                </svg>
              </a>
            </li>
          <% } %>

      </ul>
    </nav>
<% } %>
`;
var klevuLandingTemplateProductBlockCustom = `
<%
  function updatePortugueseURL(url) {
    // Check if the URL contains '/pt/' to ensure we're replacing the correct part
    if (url.includes("/pt/")) {
        // Replace '/pt/' with '/pt-pt/'
        let updatedURL = url.replace("/pt/", '/pt-pt/');
        return updatedURL;
    } else {
        return url; // Return original URL if no replacement is needed
    }
  }

  var updatedProductName = dataLocal.name;
  if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
      if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
          updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
      }
  }
  
  if(Shopify.locale == "en") {
    
    var productHandle = dataLocal.url.replace("http://" + window.location.host + "/products/", "");
        productHandle = productHandle.replace("https://" + window.location.host + "/products/", "");
    
  } else if(Shopify.locale == "pt-pt") {
    var productHandle = dataLocal.url.replace("http://" + window.location.host + "/products/", "");
    productHandle = productHandle.replace("https://" + window.location.host + "/products/", "");
    productHandle = updatePortugueseURL(productHandle);
  } else {
    var productHandle = dataLocal.url.replace("eu.", "").replace("http://" + window.location.host + "/" + Shopify.locale + "/products/", "");
        productHandle = productHandle.replace("https://" + window.location.host + "/" + Shopify.locale + "/products/", "");
  }

%>
    <li ku-product-block class="grid__item klevuProduct klevuProductClick kuTrackRecentView" data-id="<%= dataLocal.id %>">
      <product-card-klevu data-handle="<%=productHandle%>"></product-card-klevu>
    </li>
`;

var klevuLandingTemplateResultsCustom = `
<div class="kuResultsListing">
        <div class="productList klevuMeta" data-section="productList">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section class="filter-sidebar" ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets"> 
                                <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>                               
                                <%=helper.render('filters',scope,data,"productList") %>
                            </div>
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                            
                            <header ku-block data-block-id="ku_landing_result_header">
                            <button class="kuFilterButton"><%=helper.translate("Filters")%></button>
                                <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                                <%=helper.render('filtersTop',scope,data,"productList") %>
                                
                                <% if(helper.hasResults(data,"productList")) { %>
                                    <%=helper.render('sortBy',scope,data,"productList") %>
                                    <%=helper.render('limit',scope,data,"productList") %>
                                    <%=helper.render('kuTemplateLandingResultsViewSwitch',scope,data,"productList") %>
                                <% } %>
                                <div class="kuClearBoth"></div>
                            </header>

                            <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuResults">
                                    <% if(helper.hasResults(data,"productList")) { %>
                                        <ul class="grid product-grid grid--2-col-tablet-down grid--3-col-desktop">
                                            <% helper.each(data.query.productList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                                    <%=helper.render('productBlock',scope,data,item) %>
                                                <% } %>
                                            <% }); %>
                                        </ul>
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                            </div>
                                <%=helper.render('resultsShowing',scope,data,"productList") %>
                                <% if(helper.hasResults(data,"productList")) { %>
                                    <%=helper.render('pagination',scope,data,"productList") %>
                                <% } %>
                                <div class="kuClearBoth"></div>
                            
                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>                               
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>
                    
                </div>
            </div>
        </div>

        <% if(data.query.contentList) { %>
            <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
                <div class="kuResultContent">
                    <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">
    
                        <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                            <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                                <div ku-block data-block-id="ku_landing_left_facets">
                                    
                                    <%=helper.render('filters',scope,data,"contentList") %>
    
                                </div>
                                <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                                <div ku-block data-block-id="ku_landing_left_banner"></div>
                            </section>
                            <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                                
                                <header ku-block data-block-id="ku_landing_result_header">
                                    <%=helper.render('filtersTop',scope,data,"contentList") %>
                                    <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                    <% if(helper.hasResults(data,"contentList")) { %>
                                        <%=helper.render('limit',scope,data,"contentList") %>
                                        <%=helper.render('pagination',scope,data,"contentList") %>
                                    <% } %>
                                    <div class="kuClearBoth"></div> 
                                </header>

                                <div ku-block data-block-id="ku_landing_result_items">
                                    <div class="kuClearBoth"></div>
                                    <div class="kuResults">
                                        <% if(helper.hasResults(data,"contentList")) { %>
                                            <ul>
                                                <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                    <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                        <%=helper.render('contentBlock',scope,data,item) %>
                                                    <% }%>
                                                <% }); %>
                                            </ul>
                                        <% } else { %>
                                            <div class="kuNoRecordsFoundLabelTextContainer">
                                                <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                            </div>
                                        <% } %>
                                        <div class="kuClearBoth"></div>
                                    </div>
                                </div>
                                <div ku-block data-block-id="ku_landing_other_items">
                                    <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                                </div>
                                <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                            </section>
                            <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                                <div ku-block data-block-id="ku_landing_right_facets"></div>
                                <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                                <div ku-block data-block-id="ku_landing_right_banner"></div>
                            </section>
                        </div>
                        
                    </div>
                </div>
            </div>
        <% } %> 

    </div>
`;

var klevuLandingTemplateSortByCustom = `
  
<div class="kuDropdown kuDropSortBy" role="listbox">
        <div class="kuDropdownLabel">
          <span class="kuSortbyLabel"><%=helper.translate('Sort by')%>:</span> 
          <div class="filters-toolbar__input-title"><%=helper.translate(helper.getSortByCustom(dataLocal))%></div>
        </div>
        <div class="kuDropdownOptions">
            <div class="kuDropOption kuSort" data-value="RELEVANCE" role="option"><%=helper.translate('Recommended')%></div>
            <div class="kuDropOption kuSort" data-value="PRICE_ASC" role="option"><%=helper.translate('Price, low to high')%></div>
            <div class="kuDropOption kuSort" data-value="PRICE_DESC" role="option"><%=helper.translate('Price, high to low')%></div>
            <div class="kuDropOption kuSort" data-value="NEW_ARRIVAL_DESC" role="option"><%=helper.translate('Newly released')%></div>
        </div>
    </div>
`;
var klevuQuickProductBlockTitleHeaderCustom = `
<div class="kuProductHeadingWrapper">
<div class="klevuSuggestionHeading">
        <span class="klevuHeadingText"><%=helper.translate("Products")%></span>
    </div>
    <div class="klevuProductsViewAll">
        <% var queryParam = klevu.getSetting(klevu, "settings.url.queryParam"); %>
        <a href="<%=helper.buildUrl(data.settings.landingUrl, queryParam ,helper.stripHtml(data.settings.term))%>"
            target="_parent"><%=helper.translate("View All")%></a>
    </div>
</div>
`;
var klevuQuickTemplateBaseCustom = `
<div class="klevu-fluid kuPreventDocumentClick">
<div id="klevuSearchingArea" class="klevuQuickSearchingArea">
    <div ku-container data-container-id="ku_quick_main_container" data-container-role="main">
        <header ku-container data-container-id="ku_quick_main_header_container" data-container-role="header">
            <section ku-block data-block-id="ku_quick_main_header_sub_panel"></section>
            <section ku-block data-block-id="ku_quick_main_header_banner">
                <%=helper.render('klevuQuickPromotionBanner',scope,data,"top") %>                    
            </section>
            <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                <div class="klevuSuggestionsBlock">                            
                    <%=helper.render('klevuQuickAutoSuggestions',scope) %>
                    <% if (helper.isScreenWidthSmaller()) { %>
                        <% if(data.showQuickFacetedLayoutCharLimitMessage == true) { %>
                            <% var quickFacetedLayoutMessage = (data.quickFacetedLayoutMinCharsTextValue) ? data.quickFacetedLayoutMinCharsTextValue : ""; %>
                            <% if(quickFacetedLayoutMessage != "") { %>
                                <span class="kuFacetedLayoutMinCharText"><%= helper.translate(quickFacetedLayoutMessage) %></span>
                            <% } %>                    
                        <% } else { %>
                            <% if(data.query.productList) { %>
                                <%=helper.render('klevuQuickTemplateResultsHeadingTitle',scope,data,"productList") %>
                                <%= helper.render('klevuQuickTemplateTabResults',scope) %>                                                 
                                <%= helper.render('klevuQuickProducts',scope) %>
                                <%= helper.render('klevuQuickOtherContent',scope) %>
                            <% } else { %>              
                                <div class="kuSearchPersonalizationsContainer">
                                    <%= helper.render('klevuSearchPersonalizations',scope) %>    
                                </div>
                            <% } %>  
                        <% } %>
                    <% } %>
                    <%=helper.render('klevuQuickCategorySuggestions',scope) %>
                    <% if(typeof data.query.productList !== 'undefined' && data.noResultsFoundPopularSearches && data.noResultsFoundPopularSearches.length) { %>
                      <%=helper.render('quickNoResultsPopularSearches', scope, data) %>
                    <% } %>
                </div>
            </section>
            
        </header>
        
        <% if (!helper.isScreenWidthSmaller()) { %>

        <% if(data.showQuickFacetedLayoutCharLimitMessage == true) { %>
            <% var quickFacetedLayoutMessage = (data.quickFacetedLayoutMinCharsTextValue) ? data.quickFacetedLayoutMinCharsTextValue : ""; %>
            <% if(quickFacetedLayoutMessage != "") { %>
                <span class="kuFacetedLayoutMinCharText"><%= helper.translate(quickFacetedLayoutMessage) %></span>
            <% } %>                    
        <% } else { %>
            <% if(data.query.productList) { %>
                <%=helper.render('klevuQuickTemplateResultsHeadingTitle',scope,data,"productList") %>
                <%= helper.render('klevuQuickTemplateTabResults',scope) %>                                                 
                <%= helper.render('klevuQuickProducts',scope) %>
                <%= helper.render('klevuQuickOtherContent',scope) %>
            <% } else { %>              
                <div class="kuSearchPersonalizationsContainer">
                    <%= helper.render('klevuSearchPersonalizations',scope) %>    
                </div>
            <% } %>  
        <% } %>
        <% } %>
    
        <footer ku-container data-container-id="ku_quick_main_footer_container" data-container-role="footer">
            <section ku-block data-block-id="ku_quick_main_footer_sub_panel"></section>
            <section ku-block data-block-id="ku_quick_main_footer_banner">
                <%=helper.render('klevuQuickPromotionBanner',scope,data,"bottom") %>
            </section>
        </footer> 
    </div>
</div>
</div>
`;
const klevuQuickTrendingProductBlockCustom = `
<% 
var updatedProductName = dataLocal.name;
if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
    if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
        updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
    }
}
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuQSMenuItemTarget kuTrackRecentView">
<div class="klevuProductItemTop">
    <div class="klevuQuickImgWrap">
        <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
        <img src="<%=dataLocal.image%>" origin="<%=dataLocal.image%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
    </div>
</div>
<div class="klevuProductItemBottom">
    <div class="klevuQuickProductDescBlock">
        <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
        <div class="klevuQuickProductDesc">
            <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
            <div class="klevuQuickProductPrice">
            <%
                var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
            %>
            <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                <div class="klevuQuickSalePrice kuStartPrice">
                    <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                    <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                </div>
            <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                <span class="klevuQuickOrigPrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
                <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                    <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                </span>
            <% } else if(!Number.isNaN(kuSalePrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                </span>
            <% } else if(!Number.isNaN(kuPrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
            <% } %>
        </div>
        </div>                
    </div>
</div>        
</a>  
`;

var kuFilterTagsTemplateCustom = `
  
<div class="klevu-filters-desktop">
  <% 
        var filterTagsModule = data.filterTags;
        var filterTagsData = [];
        if(dataLocal && dataLocal.length){
            filterTagsData = filterTagsModule.query[dataLocal].tags;
        }
  %>
  <% if(filterTagsData.length) { %>
    <div class="kuFilterTagsWrapper">
          <span class="ku-kuFilterTagsLabel"><%=helper.translate("Refined by") %></span>
          <span title="<%=helper.translate("Clear all") %>" class="kuFilterTagClearAll"><%= helper.translate("Clear all") %></span>
        </div> 
      <div class="kuFilterTagsContainer">

               
          <% helper.each(filterTagsData, function(key,item){ 
              var filterTagItemKey = item.key;
              var filterTagItemLabel = helper.escapeHTML(helper.translate(item.label));
              %>
              <span class="kuFilterTag" data-key="<%= filterTagItemKey %>">
                  
                  <% if (filterTagItemKey.toLowerCase() !== "sustainable") { %>
                  <span 
                      title="<%= filterTagItemLabel %>" 
                      data-value="<%= filterTagItemLabel %>" 
                      class="kuFilterTagKey"
                  ><%= helper.translate(item.label).replace("£", "") %></span>
                  <% } %>

                  <% helper.each(item.values, function(key,option){ %>
                      <span 
                          title="<%= helper.escapeHTML(helper.translate(option)) %>" 
                          data-value="<%= helper.escapeHTML(helper.translate(option)) %>" 
                          class="kuFilterTagValue">
                          <% if (filterTagItemKey.toLowerCase() !== "sustainable") { %>
                            <%= helper.translate(option) %>
                          <% } else { %>
                            Eco-conscious only
                          <% } %>
                          <span>&times;</span>
                      </span>
                  <% }); %>
              </span>
          <% }); %>
          
      </div>
  <% } %>
</div>
`;
const klevuQuickRecentViewedProductBlockCustom = `
<% 
var updatedProductName = dataLocal.name;
if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
    if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
        updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
    }
}
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuTrackRecentView kuQSMenuItemTarget">
<div class="klevuProductItemTop">
    <div class="klevuQuickImgWrap">
        <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
        <img src="<%=dataLocal.image%>" origin="<%=dataLocal.image%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
    </div>
</div>
<div class="klevuProductItemBottom">
    <div class="klevuQuickProductDescBlock">
        <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
        <div class="klevuQuickProductDesc">
            <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
            <div class="klevuQuickProductPrice">
            <%
                var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
            %>
            <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                <div class="klevuQuickSalePrice kuStartPrice">
                    <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                    <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                </div>
            <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                <span class="klevuQuickOrigPrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
                <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                    <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                </span>
            <% } else if(!Number.isNaN(kuSalePrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                </span>
            <% } else if(!Number.isNaN(kuPrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
            <% } %>
        </div>
        </div>               
    </div>
</div>       
</a>
`;
